import React, { FC } from 'react';

export const PlayIcon: FC = () => <path d="m 0 0 L 1 0.5 L 0 1 L 0 0" />;
